import axios from "axios";
import { ApiHost } from "../utils/ApiConfig";

export async function premiumRequest(token, path, options = {}) {
  try {
    const response = await axios({
      url: `${ApiHost}/premium${path}`,
      ...options,
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    if (error.response?.data instanceof Blob) {
      try {
        error.response.data = JSON.parse(await error.response.data.text());
      } catch {
        /* Odpowiedź nie zawiera JSON. */
      }
    }
    throw error;
  }
}

export const getPremiumAccount = (token) => premiumRequest(token, "/account");
export const listPremiumAccountUserIdsAdmin = async (token) =>
  (await premiumRequest(token, "/admin/accounts")).UserIds;
export const premiumError = (error) => {
  const data = error?.response?.data;
  const message = [data?.msg, data?.message, data?.detail].find(
    (value) => typeof value === "string" && value.trim(),
  );
  return message || "Nie udało się wykonać operacji. Spróbuj ponownie.";
};
